import { HttpClient, MergeDataCommon, AMCDateUtil, AMCFundStatusUtil } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";
import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";

class CamcFundDividend {
    constructor(fundCode, dividendWrapper) {
        this.inactiveMessage = "待更新";
        this.emptyMessage = "本基金暂无分红";
        this.emptyMessageByRegion = "该时间段内无分红记录";
        this.hostname = $("meta[name=data-api-origin]").attr("content");
        this.fundCode = fundCode;
        this.dividendFilterDefault = "all";
        this.fundDividendList = null;
        this.httpClient = new HttpClient();
        this.$fundDividendWrapper = $(`${dividendWrapper}`);
        this.$fundDividendContainer = this.$fundDividendWrapper.find(".grid-container");
    }

    updateTableItem(result) {}

    formatDividendData(fundDividendList) {
        for (let index = 0; index < fundDividendList.length; index++) {
            const item = fundDividendList[index];
            fundDividendList[index].payDate = MergeDataCommon.formatString(item.payDate);
            fundDividendList[index].dividendAmount = MergeDataCommon.formatNumber(item.dividendAmount);
            fundDividendList[index].recordDate = MergeDataCommon.formatString(item.recordDate);
            fundDividendList[index].reinvestmentDate = MergeDataCommon.formatString(item.reinvestmentDate);
        }
        return fundDividendList;
    }

    getFundDividendListByYear(fundDividendList, year) {
        let result = [];
        if (year != "all") {
            year = parseInt(year);
            let { startDate } = AMCDateUtil.getPreviousDateByMonths(new Date(), year * 12);
            fundDividendList.forEach((item) => {
                const payDate = new Date(item.payDate);
                if (startDate <= payDate) {
                    result.push(item);
                }
            });
        } else {
            result = fundDividendList;
        }
        return result;
    }

    setMessage($fundDividendWrapper, message) {}

    errorHandler() {}

    showDividendContainer() {
        this.$fundDividendContainer.removeClass("hide");
    }

    async render() {
        if (!(await AMCFundStatusUtil.getFundStatus())) {
            this.setMessage(this.$fundDividendWrapper, this.inactiveMessage);
            return;
        }

        let charges_api_url = FUND_API_SOURCES.DIVIDEND_SOURCE;
        let reportDateFilter = await this.getReportDateFilter();
        if (reportDateFilter) {
            let options = {
                errorHandler: () => {
                    this.errorHandler();
                },
                data: {
                    hasHistory: true,
                    fundCodes: this.fundCode,
                    reportDateFilter: reportDateFilter,
                },
            };
            const res = await this.httpClient.get(charges_api_url, options);
            if (res.data && res.data instanceof Array && res.data.length > 0) {
                this.showDividendContainer();
                this.fundDividendList = this.formatDividendData(res.data);
                this.updateDividendTable(this.fundDividendList, this.dividendFilterDefault);
            } else {
                this.setMessage(this.$fundDividendWrapper, this.emptyMessage);
            }
        } else {
            this.setMessage(this.$fundDividendWrapper, this.emptyMessage);
        }
    }

    async getReportDateFilter() {
        let reportDateFilter = null;
        try {
            let reports = await FundReportService.getFundReport(window.fundCode);
            const filteredReports = reports.filter((item) => item.dividend_doc == "true");
            if (filteredReports.length > 0) {
                reportDateFilter = filteredReports[0].excluding_date;
            }
        } catch (e) {
            console.error(e);
        } finally {
            return reportDateFilter;
        }
    }
}

export default CamcFundDividend;
